export class OfdmaRawIucProfile {
    outFramesCounter: number;
    consecutiveMinislot: number;
    dataSymbolModulation: string;
    iuc: number;
    discontinuityTime: number;
    pilotPatternIndex: number;
}
